export const SURVEY_VERSION_SCHEMA = {
  title: 'survey version schema',
  version: 0,
  description: 'Stores the survey definitions/bundles for offline rendering',
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string', // Usually a composite like 'surveyid_v1'
      maxLength: 100,
    },
    survey_id: { type: 'number' },
    version_number: {
      type: 'number',
    },
    created_at: {
      type: 'string', // Store as ISO string or timestamp
    },
    // This is the SurveyBundleI blob
    jsn_definition: {
      type: 'object',
      // properties: {
      //   id: { type: 'number' },
      //   version: { type: 'number' },
      //   updated_at: { type: 'number' },
      //   translations: { type: 'object' },
      //   lists: { type: 'array', items: { type: 'object' } },
      //   blocks: { type: 'array', items: { type: 'object' } },
      //   // settings: { type: 'object' },
      //   condition_sets: { type: 'array', items: { type: 'object' } },
      // },
    },
  },
  required: ['id', 'version_number', 'jsn_definition'],
  attachments: {},
};
